import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colors } from '@99designs/emu/settings';
import { SectionData } from '../../../pages/design-without-borders';

const Wrapper = styled.div`
    width: 10px;
    position: fixed;
    top: 40%;
    left: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    z-index: 500;
`;

const Anchor = styled.a<{ isActive: boolean }>`
    height: 10px;
    width: 10px;
    border-radius: 25px;
    cursor: pointer;
    background: ${(props) => (props.isActive ? colors.grey900 : colors.grey300)};
    position: relative;
    &:hover {
        background: ${colors.grey600};
    }
`;

interface Props {
    sectionRefs: React.MutableRefObject<Record<string, HTMLDivElement | null>>;
    sectionsData: SectionData[];
    navHeight: number;
}

export default function SideNavigation({ sectionRefs, sectionsData, navHeight }: Props) {
    const [activeId, setActiveId] = useState(sectionsData[0].id);

    const sections = sectionRefs.current;

    useEffect(() => {
        // Monitoring Scroll event to update side navigation indicator
        const handleScroll = () => {
            for (const key in sections) {
                const section = sections[key];
                if (section !== null) {
                    const { offsetTop, offsetHeight } = section;

                    // Calculate whether section is in view and setActiveId
                    // Give 1px buffer, because at the edge case, it might still showing last section active
                    if (
                        window.scrollY >= offsetTop - navHeight - 1 &&
                        window.scrollY < offsetTop + offsetHeight - 1
                    ) {
                        setActiveId(key);
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sections, navHeight]);

    const handleAnchorClick = (id: string) => {
        const section = sections[id];
        if (section !== null) {
            const { offsetTop } = section;
            window.scrollTo({
                top: offsetTop - navHeight,
                behavior: 'smooth',
            });
        }
    };

    return (
        <Wrapper>
            {sectionsData.map((sectionData: SectionData, index: number) => (
                <Anchor
                    key={index}
                    isActive={sectionData.id === activeId}
                    onClick={() => handleAnchorClick(sectionData.id)}
                />
            ))}
        </Wrapper>
    );
}
